import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import DataTable from '../../components/admin/DataTable';
import api from '../../utils/api';
import './BookingListPage.css';

const BookingListPage = () => {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('ALL');

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const res = await api.get('/bookings');
      setBookings(res.data);
    } catch (error) {
      console.error('Failed to fetch bookings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await api.patch(`/bookings/${id}/status`, { status: newStatus });
      fetchBookings();
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };

  const filtered = (() => {
    if (filter === 'ALL') return bookings;
    if (filter === 'PREPARATION') return bookings.filter(b => b.inPreparation === true);
    return bookings.filter(b => b.status === filter);
  })();

  const columns = [
    {
      key: 'bookingCode',
      label: 'Code',
      render: (row) => (
        <span className="booking-code-cell">
          <strong>{row.bookingCode}</strong>
          {row.inPreparation && <span className="preparation-badge">준비중</span>}
        </span>
      ),
    },
    { key: 'locationId', label: 'Location' },
    { key: 'courseId', label: 'Course' },
    { key: 'bookingDate', label: 'Date' },
    { key: 'bookingTime', label: 'Time' },
    { key: 'contactName', label: 'Customer' },
    {
      key: 'status',
      label: 'Status',
      render: (row) => (
        <select
          className={`status-select ${row.status.toLowerCase()}`}
          value={row.status}
          onChange={(e) => { e.stopPropagation(); handleStatusChange(row.id, e.target.value); }}
          onClick={(e) => e.stopPropagation()}
        >
          <option value="PENDING">Pending</option>
          <option value="CONFIRMED">Confirmed</option>
          <option value="COMPLETED">Completed</option>
          <option value="CANCELLED">Cancelled</option>
        </select>
      ),
    },
    {
      key: 'price',
      label: 'Price',
      render: (row) => `${row.price?.toLocaleString()} ฿`,
    },
  ];

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-loading">Loading...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="booking-list-page">
        <div className="page-header">
          <h1>Bookings</h1>
          <div className="filter-tabs">
            {['ALL', 'PENDING', 'CONFIRMED', 'COMPLETED', 'CANCELLED', 'PREPARATION'].map((s) => {
              const label = s === 'ALL'
                ? 'All'
                : s === 'PREPARATION'
                  ? '준비중'
                  : s.charAt(0) + s.slice(1).toLowerCase();
              const count = s === 'ALL'
                ? bookings.length
                : s === 'PREPARATION'
                  ? bookings.filter(b => b.inPreparation === true).length
                  : bookings.filter(b => b.status === s).length;
              return (
                <button
                  key={s}
                  className={`filter-tab ${filter === s ? 'active' : ''}`}
                  onClick={() => setFilter(s)}
                >
                  {label}
                  <span className="filter-count">{count}</span>
                </button>
              );
            })}
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filtered}
          onRowClick={(row) => navigate(`/admin/bookings/${row.id}`)}
          emptyMessage="No bookings found"
        />
      </div>
    </AdminLayout>
  );
};

export default BookingListPage;
